import Modal from "semantic-ui-react/dist/commonjs/modules/Modal";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import { ModalProps } from "semantic-ui-react/dist/commonjs/modules/Modal/Modal";
import React from "react";
import { ButtonsTranslation } from "i18n/components/Buttons/typing";
import { ButtonsTexts } from "i18n/components/Buttons";

import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import { PricingCardsTranslations } from "i18n/containers/Pricing/PricingCards/typing";
import { PricingCardsTexts } from "i18n/containers/Pricing/PricingCards";
import { ProductKeys } from "containers/Pricing/products";
import { ListOfBusinessProfilesFieldForSubscriptions } from "containers/Pricing/card-plans/card-plans-checkout-modal/fields/ListOfBusinessProfilesFieldForSubscriptions";
import {useLocales} from "@libs";

const ElearningCheckoutModal = (props: {
	modalProps: ModalProps;
	onClose: () => void;
	onPay: (event: any, businessProfile: BusinessProfileModel, quantity: number) => void;
	loading: boolean;
}) => {
	const { modalProps, onClose, onPay, loading } = props;
	const {currentShortLocale} = useLocales();
	const pricingCardsTranslations: PricingCardsTranslations = {
		...PricingCardsTexts[currentShortLocale],
	};
	const buttonTranslation: ButtonsTranslation = {
		...ButtonsTexts[currentShortLocale],
	};
	const [checkoutState, setCheckoutState] = React.useState({
		quantity: 1,
		businessProfile: BusinessProfileModel.generateEmpty(),
	});
	const handleOnSelectBusinessProfile = (businessProfile: BusinessProfileModel) => {
		setCheckoutState({
			...checkoutState,
			businessProfile,
		});
	};
	const handleOnPay = (e: any) => {
		onPay(e, checkoutState.businessProfile, checkoutState.quantity);
	};

	return (
		<Modal
			size={"small"}
			{...modalProps}
		>
			<Modal.Header>Elearning Checkout</Modal.Header>
			<Modal.Content>
				<p>{pricingCardsTranslations.selectBusinessProfile}</p>
				<ListOfBusinessProfilesFieldForSubscriptions
					onSelectBusinessProfile={handleOnSelectBusinessProfile}
					typeOfProduct={ProductKeys.Elearnings}
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button
					basic
					onClick={onClose}
					loading={loading}
					disabled={loading}
				>
					{buttonTranslation.cancel}
				</Button>
				<Button
					positive
					onClick={handleOnPay}
					loading={loading}
					icon={"cart"}
					action={{
						color: "teal",
						labelPosition: "left",
						icon: "cart",
						content: "Checkout",
					}}
					actionPosition="left"
					content={buttonTranslation.continue}
					disabled={loading || !checkoutState.businessProfile.info.id}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default ElearningCheckoutModal;
